import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Text,
  Button,
  Box,
  Link,
} from '@chakra-ui/react';
import { useIsMobile } from 'app/utils/hooks';

interface ProfileVisibilityDialogProps {
  open: boolean;
  close: () => void;
}

export const ProfileVisibilityDialog: FC<ProfileVisibilityDialogProps> = ({
  open,
  close,
}) => {
  const isMobileView = useIsMobile(false);
  return (
    <Modal
      isOpen={open}
      onClose={close}
      size={isMobileView ? 'mobile' : 'default'}
    >
      <ModalOverlay />
      <ModalContent maxWidth="600px">
        <ModalHeader data-testid="dialog-title" title="Profile Visibility">
          Profile Visibility and Privacy
        </ModalHeader>
        <ModalBody>
          <Text
            fontWeight={400}
            fontSize="md"
            color="textSubdued"
            letterSpacing="0.15px"
            lineHeight="large"
            data-testid="dialog-content"
          >
            Your profile is searchable by other Session Studio users so they can
            easily invite you to Song projects. To edit this please see Privacy
            Settings.
          </Text>
          <Box marginTop={4} onClick={close}>
            <Link
              as={RouterLink}
              to={routes.privacySettings.path}
              textDecoration="none"
              _hover={{ textDecoration: 'none' }}
              _active={{ textDecoration: 'none' }}
              _focus={{ textDecoration: 'none' }}
              _focusVisible={{ outline: 'none' }}
            >
              <Text display="inline" fontWeight={400} fontSize="md">
                Edit Privacy
              </Text>
            </Link>
          </Box>
        </ModalBody>
        <ModalFooter p={isMobileView ? 6 : 4}>
          <Button
            variant="text"
            onClick={close}
            size={isMobileView ? 'auto' : 'lg'}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
